import { Input, TimePicker } from 'antd'
import moment from 'moment'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import { getMinutes } from '../../../../../common'
import { SearchDrawerComponent } from '../../../../../components'
import { translate } from '../../../../../languages'
import { RootState } from '../../../../../stores'
import { setShiftFilter } from '../../../../../stores/actions'

const StyledRow = styled.div`
  margin-bottom: 10px;
  display: flex;
`

const StyledLabel = styled.span`
  border: 1px solid #d9d9d9;
  border-right: none;
  padding: 3px 10px;
  background-color: #fafafa;
  display: inline-flex;
`

export const SearchShiftDrawerComponent: React.FC = () => {
  const dispatch = useDispatch()
  const { language } = useSelector((state: RootState) => state.language)
  const { shiftFilter } = useSelector((state: RootState) => state.shift)
  const [filter, setFilter] = React.useState(shiftFilter)

  const body = (
    <>
      <StyledRow>
        <Input
          placeholder={translate('common.name', language)}
          addonBefore={translate('common.name', language)}
          value={filter.name}
          allowClear
          onChange={(e) =>
            setFilter({
              ...filter,
              name: e.target.value,
            })
          }
        />
      </StyledRow>
      <StyledRow>
        <StyledLabel>{translate('shift.startTime', language)}</StyledLabel>
        <TimePicker
          style={{ flexGrow: 1 }}
          format="HH:mm"
          placeholder={translate('shift.startTime', language)}
          showNow={false}
          value={
            filter.startTime
              ? moment(
                  `${filter.startTime / 3600000}:${
                    (filter.startTime % 3600000) / 60000
                  }`,
                  'HH:mm'
                )
              : undefined
          }
          onChange={(_, dateString) => {
            setFilter({
              ...filter,
              startTime: dateString
                ? getMinutes(dateString) * 60000
                : undefined,
            })
          }}
        />
      </StyledRow>
      <StyledRow>
        <StyledLabel>{translate('shift.endTime', language)}</StyledLabel>
        <TimePicker
          style={{ flexGrow: 1 }}
          format="HH:mm"
          placeholder={translate('shift.endTime', language)}
          showNow={false}
          value={
            filter.endTime
              ? moment(
                  `${filter.endTime / 3600000}:${
                    (filter.endTime % 3600000) / 60000
                  }`,
                  'HH:mm'
                )
              : undefined
          }
          onChange={(_, dateString) => {
            setFilter({
              ...filter,
              endTime: dateString ? getMinutes(dateString) * 60000 : undefined,
            })
          }}
        />
      </StyledRow>
      <StyledRow>
        <Input
          placeholder={translate('common.station', language)}
          addonBefore={translate('common.station', language)}
          value={filter.stationName}
          allowClear
          onChange={(e) =>
            setFilter({
              ...shiftFilter,
              stationName: e.target.value,
            })
          }
        />
      </StyledRow>
    </>
  )

  return (
    <SearchDrawerComponent
      body={body}
      onSearch={() =>
        dispatch(
          setShiftFilter({
            ...filter,
            startTime: filter.startTime
              ? filter.endTime && filter.startTime > filter.endTime
                ? filter.endTime
                : filter.startTime
              : undefined,
            endTime: filter.endTime
              ? filter.startTime && filter.endTime < filter.startTime
                ? filter.startTime
                : filter.endTime
              : undefined,
          })
        )
      }
    />
  )
}
